import React from 'react';
import { Alert } from 'reactstrap';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Reusable notification alert component
 *
 * @param {string} type - Alert type (success, error, warning, info)
 * @param {string} message - Alert message
 * @param {function} onClose - Function to call when alert is closed
 * @param {boolean} dismissible - Whether the alert can be dismissed (default: true)
 * @param {boolean} animated - Whether to animate the alert (default: true)
 * @param {string} className - Additional CSS classes
 */
const NotificationAlert = ({
  type,
  message,
  onClose,
  dismissible = true,
  animated = true,
  className = '',
}) => {
  if (!message) return null;

  const colorMap = {
    success: 'success',
    error: 'danger',
    warning: 'warning',
    info: 'info',
  };

  const alertColor = colorMap[type] || 'info';

  const alertContent = (
    <Alert
      color={alertColor}
      className={`mb-3 ${className}`}
      isOpen={!!message}
      toggle={dismissible ? onClose : undefined}
    >
      {message}
    </Alert>
  );

  if (animated) {
    return (
      <AnimatePresence>
        {message && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            {alertContent}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return alertContent;
};

export default NotificationAlert;
